/**
 * NoAccessPage (V37)
 *
 * 권한이 부여되지 않은 직원(employee)에게 표시되는 페이지입니다.
 * - userType === 'employee' && roleIds.length === 0 인 경우
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { ShieldX, LogOut } from 'lucide-react';
import { auth } from '../../firebase/config';

export function NoAccessPage() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      if (auth) {
        await signOut(auth);
      }
      navigate('/login');
    } catch (err) {
      console.error('로그아웃 실패:', err);
      navigate('/login');
    }
  };

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {/* 아이콘 */}
        <div style={iconContainerStyle}>
          <ShieldX size={64} color="#ef4444" />
        </div>

        {/* 메인 메시지 */}
        <h1 style={titleStyle}>권한이 부여되지 않았습니다</h1>
        <p style={messageStyle}>관리자에게 문의하세요.</p>

        {/* 부가 안내 */}
        <p style={subMessageStyle}>
          권한이 부여되면 다시 로그인해주세요.
        </p>

        {/* 로그아웃 버튼 */}
        <button onClick={handleLogout} style={buttonStyle}>
          <LogOut size={18} />
          로그아웃
        </button>
      </div>
    </div>
  );
}

// 스타일
const containerStyle: React.CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#f3f4f6',
  padding: '20px',
};

const cardStyle: React.CSSProperties = {
  backgroundColor: 'white',
  borderRadius: '12px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  padding: '48px 40px',
  maxWidth: '420px',
  width: '100%',
  textAlign: 'center',
};

const iconContainerStyle: React.CSSProperties = {
  marginBottom: '24px',
};

const titleStyle: React.CSSProperties = {
  fontSize: '22px',
  fontWeight: '700',
  color: '#1f2937',
  margin: '0 0 12px 0',
};

const messageStyle: React.CSSProperties = {
  fontSize: '16px',
  color: '#4b5563',
  margin: '0 0 8px 0',
};

const subMessageStyle: React.CSSProperties = {
  fontSize: '14px',
  color: '#9ca3af',
  margin: '0 0 32px 0',
};

const buttonStyle: React.CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  padding: '12px 24px',
  fontSize: '15px',
  fontWeight: '500',
  color: '#6b7280',
  backgroundColor: 'white',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  cursor: 'pointer',
};
